'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalWizardStepComponent = exports.rentalWizardStepComponent = {
    template: require('./rental-wizard-step.html'),
    controllerAs: 'vmWizardStep',
    bindings: {
        showStep: '<',
        menuLabel: '<',
        isValid: '<'
    },
    require: {
        wizard: '^rentalWizard'
    },
    transclude: true,
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.isActive = false;
        vm.setIsActive = setIsActive;

        function init() {
            if (vm.showStep !== false) {
                vm.wizard.registerStep(vm);
                vm.wizard.registerMenuStep(vm.menuLabel);
            }
        }

        function setIsActive() {
            vm.isActive ? vm.isActive = false : vm.isActive = true;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-checkout-wizard/rental-wizard-step.js
// module id = 994
// module chunks = 0